import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  DEFAULT_SALES_TRANSACTION_FILTERS,
  mergeSalesTransactionFilters,
  parseSalesTransactionFilters,
  type SalesTransactionFilters,
} from './salesTransactionFilterParams';

export type {
  SalesTransactionFilters,
  StatusFilter,
  TypeFilter,
  PaymentMethodFilter,
  SortKey,
  SortDir,
} from './salesTransactionFilterParams';

export const useSalesTransactionFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filters = useMemo(
    () => parseSalesTransactionFilters(searchParams),
    [searchParams]
  );

  const listSearch = searchParams.toString();

  const updateFilters = useCallback(
    (patch: Partial<SalesTransactionFilters>, options?: { replace?: boolean }) => {
      setSearchParams(mergeSalesTransactionFilters(searchParams, patch), {
        replace: options?.replace ?? true,
      });
    },
    [searchParams, setSearchParams]
  );

  const clearFilters = useCallback(() => {
    setSearchParams({}, { replace: true });
  }, [setSearchParams]);

  const hasActiveFilters = useMemo(() => {
    return (
      filters.searchQuery !== DEFAULT_SALES_TRANSACTION_FILTERS.searchQuery ||
      filters.customerFilter !== DEFAULT_SALES_TRANSACTION_FILTERS.customerFilter ||
      filters.statusFilter !== DEFAULT_SALES_TRANSACTION_FILTERS.statusFilter ||
      filters.typeFilter !== DEFAULT_SALES_TRANSACTION_FILTERS.typeFilter ||
      filters.paymentMethodFilter !== DEFAULT_SALES_TRANSACTION_FILTERS.paymentMethodFilter ||
      filters.datePreset !== DEFAULT_SALES_TRANSACTION_FILTERS.datePreset
    );
  }, [filters]);

  return {
    filters,
    listSearch,
    updateFilters,
    clearFilters,
    hasActiveFilters,
  };
};
